import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/homeData';

export default function HeroSection() {
  const hero = heroArticles[0];

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-transparent z-10" />

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 min-h-[520px] md:min-h-[640px]">
        <div className="relative z-20 flex flex-col justify-center px-6 md:px-10 lg:px-16 py-16 md:py-20 order-2 lg:order-1">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-label font-medium mb-6 w-fit">
            {hero.category}
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-6">
            {hero.title}
            <br />
            {hero.titleLine2}
          </h1>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mb-8">
            {hero.description}
          </p>

          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="group inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-900 text-background-50 text-sm font-label font-medium hover:bg-primary-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              阅读全文
              <span className="w-6 h-6 rounded-full border border-background-50/30 flex items-center justify-center transition-transform duration-200 group-hover:translate-x-0.5">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
            <span className="text-xs text-foreground-500">
              <i className="ri-eye-line mr-1"></i>
              {(hero.views / 10000).toFixed(0)}万 阅读
            </span>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 h-[280px] md:h-[400px] lg:h-full overflow-hidden">
          <img
            src={hero.image}
            alt={hero.title}
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-r lg:bg-gradient-to-l from-transparent to-background-50/60 lg:to-transparent" />
        </div>
      </div>
    </section>
  );
}